import { CamelCase, camelCase } from "src/lib/aikagi"
import { SMOOTH_SMOOTHER_API_URL } from "src/lib/constants"
import useSWR from "swr"
import { useSmoothApi } from "./useSmoothApi"

export type MovingApplication = CamelCase<{
  id: number
  proposal_id: number
  status: number
  house_name: string
  room_name: string
  ad_price: number
  rent_price: number
  rough_estimate_initial_cost: number
  application_on: string
  moving_target_on: string
  payment_initial_cost_on: string
  payment_initial_cost_on_memo: string
  moving_on: string
  initial_cost: number
  enabled: "true"
  version: number
  created_at?: "2022-02-23T15:56:11.000+09:00"
  updated_at?: "2022-02-23T15:56:11.000+09:00"
  address: string
  store_contracted_on: string
  property_id: number
  total_initial_cost: number
  agreed_at?: string // 賃貸借契約締結日 (date型)
  brokerage_fee: number
  administrative_fee: number
  self_pay_amount: number
}>

export const useAdoptedMovingApplicationSWR = (proposalId: number) => {
  const { getWithToken } = useSmoothApi()

  const url =
    proposalId > 0
      ? SMOOTH_SMOOTHER_API_URL + "/proposals/" + proposalId + "/adopted_moving_application"
      : null

  const adoptedMovingApplicationSWR = useSWR(url, async (url) => {
    const res = await getWithToken(url)
    const data = camelCase(res.data)["data"] as MovingApplication
    return data
  })

  return { ...adoptedMovingApplicationSWR, url }
}
